var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 30.6V22.6H22.0999V30.6H19.8999Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8999 30.6V22.6H28.0999V30.6H25.8999Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6001 15V12.3C18.6001 10.9925 19.5926 10 20.9001 10H27.2001C28.5076 10 29.5001 10.9925 29.5001 12.3V15H37V17.2H35.0999V33.5C35.0999 36.1075 33.0074 38.2 30.3999 38.2H17.5999C14.9924 38.2 12.8999 36.1075 12.8999 33.5V17.2H11V15H18.6001ZM20.8001 12.3C20.8001 12.2567 20.8076 12.2329 20.8112 12.2238C20.8132 12.219 20.8154 12.2153 20.8154 12.2153C20.8154 12.2153 20.8191 12.2131 20.8239 12.2111C20.833 12.2075 20.8568 12.2 20.9001 12.2H27.2001C27.2434 12.2 27.2672 12.2075 27.2763 12.2111C27.2811 12.2131 27.2848 12.2153 27.2848 12.2153C27.2848 12.2153 27.287 12.219 27.289 12.2238C27.2926 12.2329 27.3001 12.2567 27.3001 12.3V15H20.8001V12.3ZM15.0999 17.2V33.5C15.0999 34.8925 16.2074 36 17.5999 36H30.3999C31.7924 36 32.8999 34.8925 32.8999 33.5V17.2H15.0999Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteLight);
export default __webpack_public_path__ + "static/media/icon_delete_light.1fd6755f.svg";
export { ForwardRef as ReactComponent };